import { Button, Icon, pxToRem, Tag } from '@lbcamden/lib-react';
import { FunctionComponent, useEffect, useState } from 'react';

import { pcfraConfigEntries } from '../../config';
import { PcfraSection, SectionCompletion } from '../../types';
import {
  Section,
  SectionSelectorRoot,
  CollapsibleContent,
  CollapsibleRoot,
  CollapsibleTrigger,
} from './SectionSelector.styled';

type Props = {
  collapsible?: boolean;
  sectionCompletion: SectionCompletion;
  isViewingErrors?: boolean;
  disabled?: boolean;
  onClickBackToStart?(): void;
  onClickSection(section: PcfraSection): void;
};

export const SectionSelector: FunctionComponent<Props> = ({
  collapsible,
  sectionCompletion,
  isViewingErrors,
  disabled,
  onClickBackToStart,
  onClickSection,
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (isViewingErrors) {
      setOpen(true);
    }
  }, [isViewingErrors]);

  const content = (
    <SectionSelectorRoot>
      {onClickBackToStart && (
        <Section onClick={onClickBackToStart}>
          <Button $variant="link" $color="primary" disabled={disabled} onClick={onClickBackToStart}>
            Back to start
          </Button>
        </Section>
      )}
      {pcfraConfigEntries.map(([section, { title }]) => {
        const isComplete = !!sectionCompletion[section];

        return (
          <Section key={section}>
            <Button
              $variant="link"
              $color="primary"
              disabled={disabled}
              onClick={() => onClickSection(section)}
            >
              {title}
            </Button>
            <Tag
              data-testid={`${title} - status`}
              $type={isComplete ? 'success' : 'info'}
              $textVariant="body2"
            >
              {isComplete ? 'Complete' : 'Incomplete'}
            </Tag>
          </Section>
        );
      })}
    </SectionSelectorRoot>
  );

  return collapsible ? (
    <CollapsibleRoot open={open} onOpenChange={setOpen}>
      <CollapsibleTrigger $open={open}>
        Jump to section
        <Icon icon="ui/chevron-light" width={pxToRem(12)} />
      </CollapsibleTrigger>
      <CollapsibleContent>{content}</CollapsibleContent>
    </CollapsibleRoot>
  ) : (
    <SectionSelectorRoot>{content}</SectionSelectorRoot>
  );
};
